import * as types from './Version.types';

const initialState = {};

const version = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_VERSION_WEB_API_SUCCESS:
      return Object.assign({}, state, action.version);

    default:
      return state;
  }
};

export default version;
